type Props = { message?: string };

export const LoadingOverlay = ({ message }: Props) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/70">
    <div className="flex flex-col items-center gap-4 rounded-md bg-card p-6 shadow">
      <svg
        className="h-14 w-14 text-primary animate-shake"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <g fill="currentColor">
          <rect x="6" y="20" width="40" height="14" rx="4" opacity="0.95" />
          <rect x="46" y="16" width="12" height="6" rx="2" opacity="0.95" />
          <path
            d="M12 24h10"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            fill="none"
            className="opacity-80"
          />
          <path
            d="M12 28h10"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            fill="none"
            className="opacity-80"
          />
          <g
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            fill="none"
            className="opacity-95"
          >
            <path d="M34 34v10" />
            <path d="M38 34v10" />
            <path d="M34 44c2 2 6 2 8 0" />
          </g>
        </g>
        <rect x="6" y="42" width="52" height="6" rx="3" fill="currentColor" opacity="0.06" />
      </svg>
      <div className="text-sm text-foreground">{message || "Preparing your meal"}</div>
    </div>
  </div>
);
